<template>
  <div>
    <headerNav title="我的优惠券" />
    <van-cell-group>
      <van-cell title="优惠活动" value="去领券" to="/user/coupon/available" is-link />
    </van-cell-group>
    <van-tabs v-model="tabIndex">
      <van-tab title="未使用">
        <ul>
          <van-list v-model="loading" :finished="finished" @load="onLoad">
            <li
              v-for="(item, index) in list"
              :key="index"
              :class="'couponitem ' + (item.show ? 'show' : '')"
            >
              <div class="couponTop">
                <div class="cpnamount">
                  <div class="amountWrap">
                    <div class="amount">
                      <span class="amountSign">￥</span>
                      <span class="amountNum">{{ item.price }}</span>
                    </div>
                    <div class="condition">
                      <span>{{
                        item.minSellPrice > 0
                          ? "满" + item.minSellPrice + "元可用"
                          : "无门槛"
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="couponInfoWrap">
                  <div class="cpninfo">
                    <div class="detail">
                      <span class="name">{{ item.couponTypeName }}</span>
                    </div>
                    <span v-if="item.isDisable" style="color:red">您当前代理等级不符合使用条件</span>
                  </div>
                  <div class="validity">
                    <span
                      >过期时间：{{
                        item.effActiveDay == 0 ? "无限制" : item.expireDate
                      }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="couponMid" v-if="item.Info != ''">
                <span>详细信息</span>
                <van-icon name="arrow" class="down" @click="onShowInfo(index)" />
              </div>
              <div class="info">
                <div class="text" v-if="item.couponType == 1">
                  可参与品类：
                  <div
                    v-for="(cate, index2) in item.cates"
                    :key="index2"
                    style="margin: 5px"
                  >
                    <van-tag type="primary"> {{ cate.cateName }}</van-tag>
                  </div>
                </div>
                <div class="text" v-if="item.couponType == 2">
                  可参与商品：
                  <div
                    v-for="(prod, index2) in item.products"
                    :key="index2"
                    style="margin: 5px"
                  >
                    <van-tag type="primary"> {{ prod.pName }}</van-tag>
                  </div>
                </div>
              </div>
            </li>
          </van-list>
        </ul>
      </van-tab>
      <van-tab title="使用记录">
        <ul class="gray">
          <van-list v-model="useLoading" :finished="useFinished" @load="onLoadUse">
            <li v-for="(item, index) in useList" :key="index" class="couponitem">
              <div class="couponTop">
                <div class="cpnamount">
                  <div class="amountWrap">
                    <div class="amount">
                      <span class="amountSign">￥</span>
                      <span class="amountNum">{{ item.price }}</span>
                    </div>
                    <div class="condition">
                      <span>{{
                        item.minSellPrice > 0
                          ? "满" + item.minSellPrice + "元可用"
                          : "无门槛"
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="couponInfoWrap">
                  <div class="cpninfo">
                    <div class="detail">
                      <span class="name">{{ item.couponTypeName }}</span>
                    </div>
                  </div>
                  <div class="validity">
                  <span
                      >过期时间：{{
                        item.effActiveDay == 0 ? "无限制" : item.expireDate
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </li>
          </van-list>
        </ul>
      </van-tab>
      <van-tab title="已过期">
        <ul class="gray">
          <van-list v-model="endLoading" :finished="endFinished" @load="onLoadEnd">
            <li v-for="(item, index) in endList" :key="index" class="couponitem">
              <div class="couponTop">
                <div class="cpnamount">
                  <div class="amountWrap">
                    <div class="amount">
                      <span class="amountSign">￥</span>
                      <span class="amountNum">{{ item.price }}</span>
                    </div>
                    <div class="condition">
                      <span>{{
                        item.minSellPrice > 0
                          ? "满" + item.minSellPrice + "元可用"
                          : "无门槛"
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="couponInfoWrap">
                  <div class="cpninfo">
                    <div class="detail">
                      <span class="name">{{ item.couponTypeName }}</span>
                    </div>
                  </div>
                  <div class="validity">
                   <span
                      >过期时间：{{
                        item.effActiveDay == 0 ? "无限制" : item.expireDate
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </li>
          </van-list>
        </ul>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { GetCoupon, ExchangeCoupon } from "../../../api/user.js";

export default {
  components: {},
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      totalCount: 0,
      pageParams: {
        sorting: "",
        maxResultCount: 8,
        skipCount: 0,
        status: 0,
      },

      useLoading: false,
      useFinished: false,
      useList: [],
      usetotalCount:0,
      usePageParams: {
        sorting: "",
        maxResultCount: 8,
        skipCount: 0,
        status: 1,
      },

      endLoading: false,
      endFinished: false,
      endList: [],
      endtotalCount:0,
      endPageParams: {
        sorting: "",
        maxResultCount: 8,
        skipCount: 0,
        status: 2,
      },
       tabIndex:0
    };
  },
  computed: {},
  methods: {
    onLoad() {
      this.ajax
        .post("/api/services/app/PhoneCouponActive/QueryCoupons", this.pageParams)
        .then((x) => {
          this.list.push(...x.result.items);
          this.loading = false;
          this.totalCount = x.result.totalCount;
          this.pageParams.skipCount += this.pageParams.maxResultCount;
          if (this.totalCount <= this.pageParams.skipCount) {
            this.finished = true;
          }
        });
    },
    onShowInfo( index) {
        console.log(this.tabIndex)
    this.$set(this.list[index], "show", !this.list[index].show);
    },
    onLoadUse() {
     this.ajax
        .post("/api/services/app/PhoneCouponActive/QueryCoupons", this.usePageParams)
        .then((x) => {
          this.useList.push(...x.result.items);
          this.useLoading = false;
          this.usetotalCount = x.result.totalCount;
          this.usePageParams.skipCount += this.usePageParams.maxResultCount;
          if (this.usetotalCount <= this.usePageParams.skipCount) {
            this.useFinished = true;
          }
        });
    },
    onLoadEnd() {
     this.ajax
        .post("/api/services/app/PhoneCouponActive/QueryCoupons", this.endPageParams)
        .then((x) => {
          this.endList.push(...x.result.items);
          this.endLoading = false;
          this.endtotalCount = x.result.totalCount;
          this.endPageParams.skipCount += this.endPageParams.maxResultCount;
          if (this.endtotalCount <= this.endPageParams.skipCount) {
            this.endFinished = true;
          }
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.couponitem {
  padding: 0 10px;
  margin-top: 10px;
  position: relative;
  font-size: 12px;
  .couponTop {
    background-color: #fcebeb;
    border-left: 1px solid #f3d4d4;
    border-right: 1px solid #f3d4d4;
    border-bottom: 1px dashed #f3d4d4;
    border-radius: 8px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .cpnamount {
      position: relative;
      height: 90px;
      width: 34.08%;
      text-align: center;
      float: left;
      border-right: 1px dashed #f3d4d4;
    }
    .amountWrap {
      width: 100%;
      position: absolute;
      top: 50%;
      -webkit-transform: translate(0, -50%);
      transform: translate(0, -50%);
      .amount {
        font-size: 15px;
        .amountSign {
          margin-right: 3px;
        }
        .amountNum {
          font-size: 39px;
          line-height: 1;
          font-weight: bold;
        }
      }
    }
  }
  .couponInfoWrap {
    position: relative;
    margin-left: 37.465%;
    height: 90px;
    .cpninfo {
      position: absolute;
      top: 26px;
      -webkit-transform: translate(0, -50%);
      transform: translate(0, -50%);
      width: 100%;
      .detail {
        padding-right: 15px;
        word-break: break-all;
        .name {
          font-size: 13px;
          color: #000;
        }
      }
    }
    .validity {
      position: absolute;
      bottom: 16px;
      font-size: 12px;
    }
    button {
      right: 16px;
      position: absolute;
      bottom: 40px;
    }
  }
  .couponMid {
    position: relative;
    height: 31px;
    line-height: 31px;
    padding-left: 16px;
    font-size: 12px;

    background-color: #fcebeb;
    border-left: 1px solid #f3d4d4;
    border-right: 1px solid #f3d4d4;
    border-bottom: 1px solid #f3d4d4;
    border-radius: 8px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    i {
      right: 16px;
      position: absolute;
      top: 8px;
      -webkit-transform: rotate(90deg);
      transform: rotate(90deg);
    }
  }

  .info {
    display: none;
    background-color: #fcebeb;
    border-left: 1px solid #f3d4d4;
    border-right: 1px solid #f3d4d4;
    border-bottom: 1px solid #f3d4d4;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    padding: 10px 25px 12px 15px;
    font-size: 12px;
  }
}
.show {
  .couponMid {
    border-bottom: 1px dashed #f3d4d4;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    i {
      -webkit-transform: rotate(-90deg);
      transform: rotate(-90deg);
    }
  }
  .info {
    display: block;
  }
}
.gray {
  -webkit-filter: grayscale(100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(graysale=1);
}
</style>
